export class GetGalleryPhotoOption {
    constructor(optionalOptions = {}) {
        this._options = document.querySelectorAll('[data-action="gallery-photo-option"]');

        if (!this._options) {
            this.destructor();
            return true;
        }

        this._options.forEach((button) => {
            button.addEventListener("click", (event) => {
                event.preventDefault()

                if (button.dataset.type && button.dataset.type === 'archive') {
                    window.closeAllModals();
                    window.showModal('gallery-photo-options-archive')
                } else {
                    window.closeAllModals();
                    window.showModal('gallery-photo-options')
                }

                return false
            })
        })
    }

    destructor() {
        this._options = null;
    }
}

export default new GetGalleryPhotoOption();